export default "__VITE_ASSET__f2JOBOIY__"